import ValueObject from "../../shared/domain/ValueObject";
import ValidationError from "../../shared/domain/exceptions/ValidationError";

export class RuleAction extends ValueObject<RuleActionEnum> {

    constructor(value: RuleActionEnum) {
        super(value);
        this.ensureValidValue(value);
    }

    private ensureValidValue(value: RuleActionEnum) {
        if (!Object.values(RuleActionEnum).includes(value)) {
            throw new ValidationError(`Invalid rule action: ${value}`);
        }
    }

    isAllow(): boolean {
        return this.value === RuleActionEnum.ALLOW;
    }

    isDeny(): boolean {
        return this.value === RuleActionEnum.DENY;
    }
}

export enum RuleActionEnum {
    ALLOW = "ALLOW",
    DENY = "DENY"
}
